import { Component, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AccountProductionState, GetAllJournalsBasedOnAccountingPeriodId } from '@app/core/Store';
import { Guid } from 'guid-typescript';
import { ConfirmationType, Modules, NotificationDetails, NotificationHeader, RoutingPath } from '@app/core/Enum';
import { Router } from '@angular/router';
import { AddClosePopupComponent, ConfirmationBoxComponent } from '../common';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-jurnals',
  templateUrl: './jurnals.component.html',
  styleUrls: ['./jurnals.component.scss']
})
export class JurnalsComponent implements OnInit {

  moduleId: number;
  modules = Modules;

  jurnalsList: any=[];

  displayedColumns: string[] = [ 'vno','status'];

  accoutingPeriodId = Guid.EMPTY as unknown as Guid;

  @Select(AccountProductionState.jurnalsList) jurnalsList$: Observable<any[]>;

  constructor( public dialog: MatDialog,private store: Store, private router : Router) { 
    
  }

  ngOnInit(): void {
    this.moduleId = Modules.ManualAccountProductionTrialBalance;
  }
onCloseClick(): void {
    this.dialog.open(AddClosePopupComponent, {});
  }
  getJurnalsList(): void {
    if (this.accoutingPeriodId) {
      this.store.dispatch(new GetAllJournalsBasedOnAccountingPeriodId(this.accoutingPeriodId)).subscribe((res) => {
      
        this.jurnalsList = res.accountProduction.jurnalsList;
        if (!this.jurnalsList || this.jurnalsList.length === 0) {
          localStorage.setItem('isJournalEmpty', 'true');
        } else {
          localStorage.setItem('isJournalEmpty', 'false');
        }
      });
    }
  }

  triggerDateChange(data: any): void {
    
    if (data.value === '-1') {

      this.accoutingPeriodId = Guid.EMPTY as unknown as Guid;
    } else {
      this.accoutingPeriodId = data.accountingPeriodId;
    }

    this.getJurnalsList();

  }

  editClick(id:Guid) : void{
    const params = { jurnalsId: btoa(id.toString()) };
      this.router.navigate([RoutingPath.ManualAccountProductionTrialBalance, params]);
  }
  ids: Array<Guid>;
  deleteClick(id:Guid) :void{
    

    if (id) {
      this.dialog
        .open(ConfirmationBoxComponent, {
          data: {
            id: id,
            type: ConfirmationType.Delete,
            moduleId: this.moduleId,
            totalNumberOfRecordSelected: 1,
            headerText: NotificationHeader.deleteConfirmation,
            detailText: NotificationDetails.deleteAllDetailText,
          },
        })
        .afterClosed()
        .subscribe((result) => {
          if (result) {
            this.ids = [];
          
            this.getJurnalsList();
          }
        });
    }
  }

  addJournal():void{
    this.router.navigate([RoutingPath.ManualAccountProductionTrialBalance]);
  }
}
